const awards = [
    {title:"IAS CMD Outstanding Chapter Award"},
    {title:"IAS CMD Most Cappening Chapter Contest 2021 Award"},
    {title:"IAS CMD Chapter Web Contest 2021 Award"},
    {title:"IEEE IAS GMP Contest 2021 ( first place with the career hunt event)"},
    {title:"The region 8 Student Branch Chapter of the Year Award 2020 - Small Category.", },
    {title:"Industry Engagement Committee Social Media Competition 2020 ", },
    {title:"Most Creative Category - The 2020 CMD Web Contest: 1st place winner", },
    {title:"2019 outstanding large IAS chapter award ", },
    {title:"2019 IEEE Region 8 PEASC Acceleration Program winner-University category for IEEE Region 8 with IAS Bootcamp. "},
    {title:"In September 2019, IEEE INSAT IAS Student Branch Chapter won the 2nd prize in Smart Green Tunisia Makeathon"},
    {title:"2019 Tunisia Section IAS Challenge: 1st place winner and announced as the organizer of the first edition of the IEEE IAS Annual Tunisia Meeting"},
    {title:"IAS Annual Meeting 2018, Oregon: Outstanding Student Branch Chapter Chair (Eya Bourguiba) "},
    {title:"Tunisian Students and Young Professionals (TSYP) 2017 Sousse, Tunisia: Certificate of Appreciation. - IAS Annual Meeting 2017, Ohio, USA: First prize of Web Design Contest. "},
    {title:"AS Annual Meeting 2015, Texas, USA: Second prize of the IAS Myron Zucker Undergraduate Student Design Contest with a project entitled \"Design and implement a simulation tool for the Reconfigurable Smart Grid\"."},
    {title:"IAS Most Impactful Webinar Contest 2021 Award"},
    {title:"IAS Chapter Web Contest Winner 2022 Award"},
]

export default awards;